<template>
    <sidebar>
    <div class="col-md-12 p-5">
      <div class="col-md-12">
        <h3 class="text-center">{{farm.id ? "Edição da Propriedade: " + farm.name : "Cadastro de Propriedades"}}</h3>
        <v-divider class="mb-7"></v-divider>
        <v-text-field
          label="Nome"
          outlined
          v-model="farm.name"
        ></v-text-field>
        <v-select
          outlined
          label="Criador"
          :items="creators"
          item-text="name"
          item-value="id"
          v-model="farm.person_id"
        ></v-select>
        <div class="mb-6">
          <v-switch
            inset
            label="Ativo"
            v-model="farm.active"
            color="var(--green)"
          ></v-switch>
        </div>
        <v-select
          outlined
          label="Período de Serviço"
          item-text="name"
          item-value="value"
          :items="computedServicePeriods"
          v-model="farm.period_service"
        ></v-select>
        <v-select
          outlined
          label="Controladores"
          item-text="name"
          item-value="id"
          :items="computedPartners"
          multiple
          v-model="farm.partners"
          :disabled="!farm.period_service"
        ></v-select>
        <v-text-field
          outlined
          label="Cod. Integração"
          v-model="farm.code_integration"
        ></v-text-field>
      </div>
      <div class="col-md-12 d-flex">
        <v-btn 
          outlined class="btn-back mr-5"
          @click="$emit('close')"
        >
          Voltar
        </v-btn>
        <v-btn 
          @click="save"
          class="success"
        >
          Salvar
        </v-btn>
      </div>
    </div>
  </sidebar>
</template>

<script>
import Sidebar from "@/components/layout/Sidebar";
import { mapActions } from 'vuex';
export default {
  name: "SidebarFarms",
  props: {
    farmEdit: Object,
    creators: Array,
    partners: Array
  },
  data() {
    return {
      farm: {}
    }
  },
  components: {
    Sidebar
  },
  computed: {
    computedServicePeriods() {
      return [
        {name: "Mensal", value: "month"},
        {name: "Bimenstral", value: "bimonth"},
      ]
    },
    computedPartners() {
      if(this.farm.period_service === "bimonth") return this.partners.filter(e => e.operation === true);
      else return this.partners;
    }
  },
  methods: {
    ...mapActions("farms", [
      "actionEditFarm",
      "actionPostFarm"
    ]),
    async save() {
      if(this.farm.id) {
        try {
          await this.actionEditFarm(this.farm);
          this.$emit("close");
        } catch(error) {
        Object.values(error.response.data).forEach(errorItem => {
          this.$toast.error(errorItem[0]);
        });
      }
      } else {
        try {
          await this.actionPostFarm(this.farm);
          this.$emit("close");
        } catch(error) {
        Object.values(error.response.data).forEach(errorItem => {
          this.$toast.error(errorItem[0]);
        });
        }
      }
    }
  },
  watch: {
    farmEdit: {
      deep: true,
      handler(val) {
        if(Object.keys(val).length) {
          this.farm = {
            id: val.id,
            name: val.name,
            person_id: val.creator.id,
            active: val.active,
            partners: val.partners.map(e => {return e.id}),
            code_integration: val.code_integration,
            period_service: val.period_service
          }
        } else {
          this.farm = {};
        }
      }
    }
  }
}
</script>

<style>

</style>